import * as THREE from 'three'

export default function tick({ update })
{
  const clock = new THREE.Clock()

  const loop = () =>
  {
    const elapsedTime = clock.getElapsedTime()

    update(elapsedTime)

    window.requestAnimationFrame(loop)
  }

  loop()
}
